import React from "react";

import "./Spacer.scss";

export default function Spacer({spacerNumber,height}) {
  return (
    <div className={!spacerNumber ? `spacer` : `spacer spacer-${spacerNumber}`} style={{ height: height }}>
      Spacer
    </div>
  );
}
